
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0.5 1 20.5 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.97 16.062v-1.668a3.336 3.336 0 00-3.336-3.336H4.961a3.336 3.336 0 00-3.336 3.336v1.668M11.633 4.385a3.336 3.336 0 11-6.672 0 3.336 3.336 0 016.672 0zM19.975 16.062v-1.668a3.336 3.336 0 00-2.502-3.225M14.137 1.16a3.337 3.337 0 010 6.462","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    